import { controls } from "../../controls";

const rp1054= {
  label: "OSC 4.2.10",
  pageLabel: "OSC 4.2.10",
  starting: true,
  url: "rp1054",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [  
   
    ...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),
    
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form:[],

  history: {
    perPage: 10,
    reportHeader: "Non-SLR securities-Shares of StCB",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
        {
            Header:"Sr. No.",
            accessor:"Sr._No.",
            rwidth:"*"
        },
        {
            Header:"Particulars",
            accessor:"particulars",
            rwidth:"*"
        },
        {
            Header:"Date of Purchase",
            accessor:"date_of_purchase",
            rwidth:"*"
        },
        
        {
            Header:"Face Value",
            accessor:"face_value",
            rwidth:"*"
        },
        {
            Header:"Book Value",
            accessor:"book_value",
            rwidth:"*"
        },
        {
            Header:"Market Value",
            accessor:"market_value",
            rwidth:"*"
        },
        {
            Header:"Difference",
            accessor:"difference",
            rwidth:"*"
        },
         {
            Header:"Depreciation (-)/Appreciation (+)",
            accessor:"depreciation_Appreciation",
            rwidth:"*"
        }  
            
    ]
  }
};

export default rp1054;